/**
 * PSX does not expose a public real-time WebSocket feed.
 * These are no-op stubs so the TradingView charting library
 * doesn't throw when it calls subscribeBars / unsubscribeBars.
 * If a live tick feed becomes available in the future, implement it here.
 */

export function subscribeOnStream(
  _symbolInfo,
  _resolution,
  _onRealtimeCallback,
  subscriberUID
) {
  console.log("[subscribeBars] PSX streaming not available – stub called for", subscriberUID);
}

export function unsubscribeFromStream(subscriberUID) {
  console.log("[unsubscribeBars] stub called for", subscriberUID);
}
